import { render, staticRenderFns } from "./OnboardingChooseProductModal.vue?vue&type=template&id=1f8073be&scoped=true"
import script from "./OnboardingChooseProductModal.vue?vue&type=script&lang=js"
export * from "./OnboardingChooseProductModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingChooseProductModal.vue?vue&type=style&index=0&id=1f8073be&prod&lang=scss&scoped=true"
import style1 from "./OnboardingChooseProductModal.vue?vue&type=style&index=1&id=1f8073be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8073be",
  null
  
)

export default component.exports